var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcUserGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.25C11.9999 6.90685 10.6567 8.25 8.99986 8.25C7.343 8.25 5.99986 6.90685 5.99986 5.25C5.99986 3.59315 7.343 2.25 8.99986 2.25C10.6567 2.25 11.9999 3.59315 11.9999 5.25Z",
    stroke: "#707275",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99986 10.5C6.86365 10.5 4.98819 11.4768 3.92506 12.9479C3.36256 13.7262 3.08131 14.1153 3.49905 14.9327C3.9168 15.75 4.61115 15.75 5.99986 15.75H11.9999C13.3886 15.75 14.0829 15.75 14.5007 14.9327C14.9184 14.1153 14.6372 13.7262 14.0747 12.9479C13.0115 11.4768 11.1361 10.5 8.99986 10.5Z",
    stroke: "#707275",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGrey);
export default __webpack_public_path__ + "static/media/ic-user-grey.8d05636f1b5873e490f4a7aa9ed9c7b0.svg";
export { ForwardRef as ReactComponent };